import * as React from "react";

function IconCe({
  size = 24,
  color = "currentColor",
  stroke = 2,
  ...props
}) {
  return <svg className="icon icon-tabler icon-tabler-ce" width={size} height={size} viewBox="0 0 24 24" strokeWidth={stroke} stroke={color} fill="none" strokeLinecap="round" strokeLinejoin="round" {...props}><path stroke="none" d="M0 0h24v24H0z" fill="none" /><path d="M11 4a8 8 0 1 0 0 16" /><path d="M20 4a8 8 0 1 0 0 16" /><line x1={12} y1={12} x2={20} y2={12} /></svg>;
}

export default IconCe;